import { faTachometerAlt, faUsersCog, faBoxOpen, faScrewdriverWrench, faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { iconLeave, iconLeaveExit, profileVerified } from "assets";
import HomeIcon from "assets/icons/home-icon";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTrigger } from "components/app/dialog/dialog";
import ImageUrl from "components/app/image-url/ImageUrl";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import SearchBar from "components/app/search-bar/SearchBar";
import { Button } from "components/ui/button";
import { Card } from "components/ui/card";
import { DialogTitle } from "components/ui/dialog";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Sheet, SheetClose, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle, SheetTrigger } from "components/ui/sheet";
import { Skeleton } from "components/ui/skeleton";
import { t } from "i18next";
import { AlarmClock, GitPullRequestArrow, HandCoins, Info, Settings, Shield } from "lucide-react";
import SettingShopDetail from "pages/business-suite/setting-shop-detail/SettingShopDetail";
import { TooltipHover } from "pages/hover-card-detail/Tooltip";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AppLog } from "services";
import { setIsSaveSetting, setUserShopProfile, setUserShops, setUserShopSelectedProfile, setRequestWorkflows, setUserShopPositions } from "store/businessSuiteSlice";
import { setIsHidden } from "store/header";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, RouteUrl, StatusMsg } from "utils";
import { Service } from "utils/services";

export default function BusinessSuiteLeftSideContent() {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const navigate = useNavigate();
  const [loadingShops, setLoadingShops] = useState<boolean>(false);

  const [searchTextShop, setSearchTextShop] = useState<string>("");
  const { userShops, userShopProfile, userShopSelectedProfile } = useAppSelector((state) => state.businessSuite);

  const [shopIdState, setShopIdState] = useState<string>("");

  let filteredShops = userShops?.filter((user: any) => user.shop_name.toString().toLowerCase().includes(searchTextShop.toLowerCase()));

  const navLink = [
    {
      name: "Profile Detail",
      url: RouteUrl.businessSuite,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-blue-500 text-white p-2 rounded-full">
          <Info />
        </div>
      ),
    },
    {
      name: "Dashboard",
      url: RouteUrl.dashboard,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-cyan-500 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faTachometerAlt} />
        </div>
      ),
    },
    {
      name: "Payroll",
      url: RouteUrl.payroll,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-orange-500 text-white p-2 rounded-full">
          <HandCoins />
        </div>
      ),
    },
    {
      name: "Leave",
      url: RouteUrl.leave,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          {/* <img src={iconLeaveExit} alt="" className="filter invert " /> */}
          <i className="fa-solid fa-person-walking-arrow-right "></i>
          {/* <HandCoins /> */}
        </div>
      ),
    },
    {
      name: "Timesheets",
      url: RouteUrl.timeSheet,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-pink-500 text-white p-2 rounded-full">
          <AlarmClock />
        </div>
      ),
    },
    {
      name: "Request",
      url: RouteUrl.request,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-teal-500 text-white p-2 rounded-full">
          {/* <FontAwesomeIcon icon={faUsersCog} /> */}
          <GitPullRequestArrow />
        </div>
      ),
    },

    // {
    //   name: "Music Libraries",
    //   url: RouteUrl.musicLibraries,
    //   icon: (
    //     <div className="w-8 h-8 flex items-center justify-center bg-lime-500 text-white p-2 rounded-full">
    //       <FontAwesomeIcon icon={faMusic} />
    //     </div>
    //   ),
    // },
    {
      name: "Products & Services",
      url: RouteUrl.productService,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-purple-500 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faBoxOpen} />
        </div>
      ),
    },
    {
      name: "Staffs",
      url: RouteUrl.staff,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-yellow-500 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faUsersCog} />
        </div>
      ),
    },
    {
      name: "Tools",
      url: RouteUrl.tools,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faScrewdriverWrench} />
        </div>
      ),
    },

    // {
    //   name: "Leads",
    //   url: RouteUrl.leads,
    //   icon: (
    //     <div className="w-8 h-8 flex items-center justify-center bg-red-500 text-white p-2 rounded-full">
    //       <FontAwesomeIcon icon={faUserPlus} />
    //     </div>
    //   ),
    // },
    // {
    //   name: "Opportunities",
    //   url: RouteUrl.opportunities,
    //   icon: (
    //     <div className="w-8 h-8 flex items-center justify-center bg-blue-600 text-white p-2 rounded-full">
    //       <FontAwesomeIcon icon={faHandHoldingUsd} />
    //     </div>
    //   ),
    // },
    // {
    //   name: "Jobs",
    //   url: RouteUrl.jobs,
    //   icon: (
    //     <div className="w-8 h-8 flex items-center justify-center bg-gray-700 text-white p-2 rounded-full">
    //       <FontAwesomeIcon icon={faBriefcase} />
    //     </div>
    //   ),
    // },
    // {
    //   name: "Events",
    //   url: RouteUrl.events,
    //   icon: (
    //     <div className="w-8 h-8 flex items-center justify-center bg-teal-500 text-white p-2 rounded-full">
    //       <FontAwesomeIcon icon={faCalendarAlt} />
    //     </div>
    //   ),
    // },
    // {
    //   name: "Projects",
    //   url: RouteUrl.projects,
    //   icon: (
    //     <div className="w-8 h-8 flex items-center justify-center bg-purple-600 text-white p-2 rounded-full">
    //       <FontAwesomeIcon icon={faTasks} />
    //     </div>
    //   ),
    // },
  ];

  function handleClickNavLink(link: string) {
    dispatch(setIsHidden(!isHidden));
    if (location.pathname !== link) {
      navigate(`${link}?id=${shopIdState}`);
    }
  }

  const fetchGetUserShopsProfile = async () => {
    try {
      setLoadingShops(true);
      let url: string = "";
      url = RouteApi.getShopUser;
      url += `token=${Service?.token}`;

      const response = await RequestApi(url);

      if (response.status === "success") {
        dispatch(setUserShops(response["user_shops"]));
      } else {
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchGetUserShopsProfile]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingShops(false);
    }
  };

  useEffect(() => {
    if (!userShopProfile && !userShops) {
      fetchGetUserShopsProfile();
    }
  }, []);

  useEffect(() => {
    dispatch(setUserShopSelectedProfile(userShopProfile));
  }, [userShopProfile]);

  useEffect(() => {
    if (userShops && shopId) {
      const filteredProfile = userShops.find((element: any) => element.shop_id === shopId);
      dispatch(setUserShopSelectedProfile(filteredProfile));
      setShopIdState(filteredProfile?.shop_id);
    }
  }, [userShops, shopId]);
  const { token } = useAppSelector((state) => state.auth);
  const [errorStatus, setErrorStatus] = useState({
    title: "",
    message: "",
  });
  const [warning, setWarning] = useState(false);
  const fetchGetUserShopProfile = async () => {
    try {
      let url: string = "";
      url = RouteApi.getAccountShopDetail;
      url += `token=${token}`;

      const data = {
        shop_id: shopId,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        dispatch(setUserShopProfile(response["user_shop"]));
        dispatch(setRequestWorkflows(response["request_workflows"]));
        dispatch(setUserShopPositions(response["user_shop_positions"]));
      } else {
        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning(true);
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchGetUserShopProfile]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
    }
  };
  const { isHidden } = useAppSelector((state) => state.header);

  return (
    // lg:w-[310px]${isHidden ? "w-[70px]" : " w-0"}
    <div className={`transition-all duration-300 ease-in-out overflow-hidden w-[70px] border-r-2`}>
      <div className="p-2  space-y-2 flex flex-col justify-between h-[calc(100vh-90px)]">
        <ScrollArea className="h-full">
          {loadingShops ? (
            <>
              <Skeleton className="w-full h-[40px] rounded-xl mt-4" />
            </>
          ) : (
            <div className="space-y-2">
              {navLink.map((link, index) => {
                return (
                  // <TooltipHover
                  <button
                    key={index}
                    onClick={() => handleClickNavLink(link.url)}
                    className={`flex items-center justify-center p-2 rounded-xl cursor-pointer w-full  ${
                      location.pathname === link.url ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900 rounded-full" : "dark:hover:bg-slate-900"
                    }`}
                  >
                    <ul>
                      <li className="flex items-center justify-center lg:justify-start space-x-0 lg:space-x-2">
                        {link.icon}
                        {/* This <p> will be hidden on mobile, shown on lg screen */}
                        {/* <p className="hidden lg:block text-sm font-medium">{link.name}</p> */}
                      </li>
                    </ul>
                  </button>
                );
              })}
            </div>
          )}
          <ScrollBar orientation="vertical" />
        </ScrollArea>
        <div className="space-y-2">
          <Sheet>
            <SheetTrigger asChild>
              <button
                onClick={() => {
                  dispatch(setIsSaveSetting(false));
                  if (!userShopProfile) {
                    fetchGetUserShopProfile();
                  }
                }}
                className="flex items-center justify-center p-2 rounded-xl cursor-pointer w-full bg-gray-200 dark:bg-accent dark:hover:bg-slate-900"
              >
                <ul>
                  <li className="flex items-center justify-center lg:justify-start space-x-0 lg:space-x-2">
                    <Settings />
                    {/* <p className="hidden lg:block text-md">Setting</p> */}
                  </li>
                </ul>
              </button>
            </SheetTrigger>
            <SheetContent className="flex flex-col h-full justify-between p-3 sm:max-w-[800px]">
              <SheetHeader>
                <SheetTitle>Setting </SheetTitle>
                <SheetDescription>Make changes to your setting here. Click save when you're done.</SheetDescription>
              </SheetHeader>
              <ScrollArea className="h-full">
                <SettingShopDetail shopId={shopId} warning={warning} errorStatus={errorStatus} />
                <ScrollBar orientation="vertical" />
              </ScrollArea>
              <SheetFooter>
                <SheetClose asChild>
                  {warning ? (
                    ""
                  ) : (
                    <Button
                      type="submit"
                      onClick={() => {
                        dispatch(setIsSaveSetting(true));
                      }}
                    >
                      Save
                    </Button>
                  )}
                </SheetClose>
              </SheetFooter>
            </SheetContent>
          </Sheet>

          {/* <button onClick={() => navigate("/")} className="p-2 rounded-xl cursor-pointer w-full bg-gray-200 dark:bg-accent dark:hover:bg-slate-900">
            <li className="flex items-center justify-center lg:justify-start space-x-0 lg:space-x-2">
              <HomeIcon />
            </li>
          </button> */}
          <button
            onClick={() => navigate("/")}
            className="flex items-center justify-center p-2 rounded-xl cursor-pointer w-full bg-gray-200 dark:bg-accent dark:hover:bg-slate-900"
          >
            <ul>
              <li className="flex items-center justify-center lg:justify-start space-x-0 lg:space-x-2">
                <HomeIcon />
                {/* <p className="hidden lg:block text-md">Home</p> */}
              </li>
            </ul>
          </button>
        </div>
      </div>
    </div>
  );
}
